import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent } from '../components/ui/card';
import { Package, FolderOpen, MessageSquare, Mail } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminDashboardPage = () => {
  const { getAuthHeader } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API}/admin/stats`, {
          headers: getAuthHeader()
        });
        setStats(response.data);
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, [getAuthHeader]);

  const statCards = [
    { title: 'Producten', value: stats?.products || 0, icon: Package, color: 'bg-blue-500', bgColor: 'bg-blue-50' },
    { title: 'Categorieën', value: stats?.categories || 0, icon: FolderOpen, color: 'bg-green-500', bgColor: 'bg-green-50' },
    { title: 'Berichten', value: stats?.messages || 0, icon: MessageSquare, color: 'bg-purple-500', bgColor: 'bg-purple-50' },
    { title: 'Ongelezen', value: stats?.unread_messages || 0, icon: Mail, color: 'bg-[#E31E24]', bgColor: 'bg-red-50' },
  ];

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="w-8 h-8 border-2 border-[#E31E24] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-gray-500 text-sm mt-1">Welkom terug bij het beheer panel</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {statCards.map((stat, index) => (
          <Card key={index} className="border-0 shadow-sm">
            <CardContent className="p-5">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-500 mb-1">{stat.title}</p>
                  <p className="text-3xl font-bold text-gray-900">{stat.value}</p>
                </div>
                <div className={`w-12 h-12 ${stat.bgColor} rounded-xl flex items-center justify-center`}>
                  <stat.icon className={`h-6 w-6 ${stat.color.replace('bg-', 'text-')}`} />
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {stats?.products === 0 && (
        <Card className="mt-6 border-0 shadow-sm">
          <CardContent className="py-12 text-center">
            <p className="text-gray-500 mb-2">Nog geen producten of categorieën.</p>
            <p className="text-gray-400 text-sm">Klik op "Demo Data Laden" in het menu om voorbeeld data te laden.</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
